import { Injectable, OnInit } from "@angular/core";
import * as moment from "moment";

@Injectable({
  providedIn: "root",
})
export class GetCurrentShift {
  getCurrentShift(shiftObject: any, timeZone: any) {
    shiftObject = shiftObject.map((x, i) => {
      x = JSON.parse(JSON.stringify(x));
      if (i === shiftObject.length - 1) x.isLastShift = true;
      else x.isLastShift = false;
      let endDateTime = undefined,
        startDateTime = undefined;
      const durationTo12 = Math.abs(
        moment
          .duration(
            moment
              .tz(
                moment.tz(timeZone).format("YYYY-MM-DD") + " 00:00:00",
                timeZone
              )
              .diff(
                moment.tz(moment.tz(timeZone).subtract(1, "minutes"), timeZone)
              )
          )
          .asHours()
      );
      const endTimeDuration = Math.abs(
        moment
          .duration(
            moment
              .tz(
                moment.tz(timeZone).format("YYYY-MM-DD") + " " + x.endTime,
                timeZone
              )
              .diff(
                moment.tz(
                  moment.tz(timeZone).format("YYYY-MM-DD") + " 00:00:00",
                  timeZone
                )
              )
          )
          .asHours()
      );
      if (
        x.endNextDayFlag &&
        durationTo12 < endTimeDuration &&
        !x.startNextDayFlag
      ) {
        endDateTime = moment(
          moment.tz(timeZone).format("YYYY-MM-DD") + " " + x.endTime
        ).format("YYYY-MM-DDTHH:mm:ss");
        startDateTime = moment(
          moment.tz(timeZone).subtract(1, "day").format("YYYY-MM-DD") +
            " " +
            x.startTime
        ).format("YYYY-MM-DDTHH:mm:ss");
        x.isNextday = true;
      } else if (x.endNextDayFlag && !x.startNextDayFlag) {
        endDateTime = moment(
          moment.tz(timeZone).add(1, "day").format("YYYY-MM-DD") +
            " " +
            x.endTime
        ).format("YYYY-MM-DDTHH:mm:ss");
      } else if (x.startNextDayFlag) {
        x.isNextday = true;
      }
      x.startDateTime =
        startDateTime ||
        moment(
          moment.tz(timeZone).format("YYYY-MM-DD") + " " + x.startTime
        ).format("YYYY-MM-DDTHH:mm:ss");
      x.start = moment.tz(x.startDateTime, timeZone).valueOf();
      x.endDateTime =
        endDateTime ||
        moment(
          moment.tz(timeZone).format("YYYY-MM-DD") + " " + x.endTime
        ).format("YYYY-MM-DDTHH:mm:ss");
      x.end = moment.tz(x.endDateTime, timeZone).valueOf();
      return x;
    });
    const currentDate = moment.tz(timeZone).format("YYYY-MM-DDTHH:mm:ss");
    let currentShift = {};
    for (const shift of shiftObject) {
      const isCurrentShift = moment(currentDate).isBetween(
        moment(shift.startDateTime),
        moment(shift.endDateTime)
      );
      if (isCurrentShift) {
        if (shift.isNextday) {
          shift["currentDate"] =
            moment.tz(timeZone).subtract(1, "days").format("YYYY-MM-DD") +
            " 00:00:00";
        } else {
          shift["currentDate"] =
            moment.tz(timeZone).format("YYYY-MM-DD") + " 00:00:00";
        }
        shift["currentDateTime"] = currentDate;
        currentShift = shift;
        break;
      }
    }
    if (shiftObject[0]) {
      const startDateTime = shiftObject[0].startDateTime.split("T")[0];

      if (startDateTime) {
        if (shiftObject[0].endNextDayFlag) {
          shiftObject[0]["shift1startDate"] =
            moment(startDateTime).subtract(1, "days").format("YYYY-MM-DD") +
            " 00:00:00";

          currentShift["shift1startDate"] = shiftObject[0]["shift1startDate"];
        } else {
          currentShift["shift1startDate"] = startDateTime;
        }
      }
    }
    return currentShift;
  }
}
